module.exports = {"230129100":"延寿镇","230129101":"六团镇","230129102":"中和镇","230129103":"加信镇","230129104":"延河镇","230129204":"安山乡","230129205":"寿山乡","230129206":"玉河乡","230129209":"青川乡","230129400":"太平川","230129500":"庆阳农场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/230129.json
// module id = 630
// module chunks = 0